<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="false">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div v-show="inn">
          Полезные ссылки
          <div><a :href="'https://atlant-smart.ru/services/entities/' + inn + '/excerpt?mode=redirect'" target="_blank">Выписка из ЕГРЮЛ/ЕГРИП с ЭЦП ФНС РФ</a></div>
          <div><a :href="'https://bo.nalog.gov.ru/search?query=' + inn + '&page=1'" target="_blank">Бухгалтерская отчетность</a></div>
          <div><a @click="open('https://kad.arbitr.ru')">Картотека арбитражных дел </a><br/>(ИНН копируется в буфер обмена)</div>
          <div><a :href="'https://fedresurs.ru/entities?searchString=' + inn" target="_blank">Федресурс (публикации существенных фактов)</a></div>
        </div>
      </div>
      </v-panel-title>
      <v-card-text v-show="isLoaded" class="pt-0">
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-links-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      inn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.id = this.inn
    },
    watch: {
      inn: function (newVal, oldVal) { // watch it
        this.id = this.inn
      }
    },
    computed: {
      ...mapGetters({
      })
    },
    methods: {
      switchItems () {
      },
      open (url) {
        this.$store.dispatch('copyToClipboard', {text: this.inn})
        this.$store.dispatch('openLocation', url)
      }
    }
  }

</script>




// WEBPACK FOOTER //
// LinksPanel.vue?077e9743